import { render, staticRenderFns } from "./PromotionManagementGrid.vue?vue&type=template&id=9622bd60&"
import script from "./PromotionManagementGrid.vue?vue&type=script&lang=ts&"
export * from "./PromotionManagementGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports